import axios from 'axios';
class PingService {
  constructor() {
  
    this.client = axios.create({
      baseURL: 'https://www.google.com/ping',
      timeout: 5000,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });
    
  }

  clear(url){
    delete axios.defaults.headers.common["Authorization"];
    
    return this.client.get(url);
  }
}

export default new PingService()
